<template>
  <div>
    <div v-if="modalShow">
      <img :src="kzNameData.src" alt="" style="height:18px;margin-right:4px;vertical-align: middle;">
      {{kzNameData.value}}
    </div>

    <div v-if="!modalShow && !modalIf" @click="openIf" style="cursor:pointer">
      <img :src="kzNameData.src" alt="" style="height:18px;margin-right:4px;vertical-align: middle;">
      {{kzNameData.value}}
    </div>

    <div v-if="modalIf">
      <Poptip v-model="modalIf"  :showPop="closeModal" trigger="click" placement="bottom-start" width="100" style="cursor: pointer">
      <span>
        <img :src="changeImg" alt="" style="height:18px;margin-right:4px;vertical-align: middle;">
        {{kzNameData.value}}
      </span>
        <div slot="content">
          <Button type="ghost" size="small" style="marign:0 10px 4px 0;display: block;" @click="changeSex(1)">
            <img src="https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/sex_male.png" alt="" style="height: 18px;margin-right:4px;vertical-align: middle;">
            先生
          </Button>
          <Button type="ghost" size="small" style="marign:0 10px 4px 0;display: block;"  @click="changeSex(2)">
            <img src="https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/sex_female.png" alt="" style="height: 18px;margin-right:4px;vertical-align: middle;">
            女士
          </Button>
        </div>
      </Poptip>
    </div>

  </div>
</template>

<script>
  import {dataDst} from '../../common/util'

  export default {
    name: "render-name",
    props:{
      kzName:{
        type:Object,
      },
      encryption:{
        type:Boolean,
      }
    },
    data() {
      return {
        modalShow: false,
        modalIf:false,
        closeModal: '关闭',
        changeImg:'',
        sexImg:{
          '0':'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/sex_null.png',
          '1':'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/sex_male.png',
          '2':'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/sex_female.png',
        }
      }
    },
    computed:{
      kzNameData(){
        let value =''
        let src = this.sexImg[this.kzName.row['sex']]
        if(this.encryption){
          value = dataDst(this.kzName.row.kzname)
          this.modalShow = true
        }else{
          value = this.kzName.row.kzname
          this.changeImg = this.sexImg[this.kzName.row.sex]
          this.modalIf = false
        }
        return {value,src,kzid:this.kzName.row.kzid}
      },
    },
    methods:{
      //修改性别
      changeSex(status){
        this.$http.post('client/edit_sex',{
          sex: status,
          kzId: this.kzNameData.kzid,
        }).then((data) => {
          if (data.code === 100000) {
          this.$Message.success(data.msg)
            this.changeImg = this.sexImg[status]
            this.closeModal = '关闭'
            return true
          } else {
            this.$Message.error(data.msg)
            return false
          }
        })

      },

      //打开 Poptip
      openIf(){
        this.modalIf = true
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render-components/render-name.vue